import { render, staticRenderFns } from "./CheckpointToolsMenuItem.vue?vue&type=template&id=40fff914&scoped=true"
import script from "./CheckpointToolsMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointToolsMenuItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointToolsMenuItem.vue?vue&type=style&index=0&id=40fff914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fff914",
  null
  
)

export default component.exports